var _path, _path2, _path3, _path4, _g, _circle, _circle2, _path5, _path6, _g2, _g3, _path7, _path8, _path9, _g4, _g5, _g6, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.45 48.39l-2.1-5.81l92.28-28.5c1.1-.37 2.3.22 2.7 1.34c.4 1.12-.14 2.34-1.22 2.77l-91.66 30.2z",
    fill: "#82aec0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.59 46.1c-7.62-5.2-10.78-5.35-13.41-5.35H25.82c-2.63 0-5.79.16-13.41 5.35C4.79 51.3 4 54.63 4 61.79v42.51c0 5.05 4.09 9.14 9.14 9.14h101.73c5.05 0 9.14-4.09 9.14-9.14V61.79c-.01-7.16-.8-10.49-8.42-15.69z",
    fill: "#de7340"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.25 51.31H12.75C7.92 51.31 4 55.23 4 60.06v55.2c0 4.83 3.92 8.75 8.75 8.75h102.51c4.83 0 8.75-3.92 8.75-8.75v-55.2c-.01-4.83-3.93-8.75-8.76-8.75z",
    fill: "#ffab00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.43 88.18H60.48c-1.67 0-3.02-1.35-3.02-3.02V68.79c0-1.67 1.35-3.02 3.02-3.02h51.96c1.67 0 3.02 1.35 3.02 3.02v16.37a3.032 3.032 0 0 1-3.03 3.02z",
    fill: "#212121"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#de7340"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72.66,
    cy: 108.23,
    r: 9.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.48,
    cy: 108.23,
    r: 9.18
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.54,
    cy: 106.36,
    r: 9.18,
    fill: "#fcebcd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.37,
    cy: 106.36,
    r: 9.18,
    fill: "#fcebcd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.97 106.21c-.35 0-.71-.11-1.01-.34l-4.79-3.64s.33-.69.89-1.42s1.13-1.24 1.13-1.24l4.79 3.64c.73.56.88 1.61.32 2.34c-.33.43-.83.66-1.33.66z",
    fill: "#78909c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#82aec0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M57.46 76.97h57.99"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#82aec0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.37 71.35h5.54v2.54h-5.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.7 71.35h5.54v2.54h-5.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.87 71.35h5.54v2.54h-5.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.03 71.35h5.54v2.54h-5.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2 71.35h5.54v2.54H72.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#82aec0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.91 80.06h3.52v2.54h-3.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.33 80.06h3.52v2.54h-3.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.76 80.06h3.52v2.54h-3.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.18 80.06h3.52v2.54h-3.52z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f7889",
    d: "M74.97 71.35h1.4v2.54h-1.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f7889",
    d: "M74.97 75.97h1.4v2.01h-1.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f44336",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M74.33 65.77v22.41"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.43 65.77c1.67 0 3.02 1.35 3.02 3.02v16.37c0 1.67-1.35 3.02-3.02 3.02H60.48c-1.67 0-3.02-1.35-3.02-3.02V68.79c0-1.67 1.35-3.02 3.02-3.02h51.95m0-2H60.48c-2.77 0-5.02 2.25-5.02 5.02v16.37c0 2.77 2.25 5.02 5.02 5.02h51.96c2.77 0 5.02-2.25 5.02-5.02V68.79a5.038 5.038 0 0 0-5.03-5.02z",
    fill: "#de7340"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.54 105.02c-.92 0-1.67-.75-1.67-1.67v-6.02s.75-.15 1.67-.15c.92 0 1.67.15 1.67.15v6.02c0 .92-.74 1.67-1.67 1.67z",
    fill: "#78909c"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#546e7a",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.94 67H46.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.94 76.01H46.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.94 85.03H46.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.94 94.04H46.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.94 103.05H46.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.94 112.06H46.8"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M117.45 71.19c0-4.33-3.07-4.7-3.07-4.7c.64.56.88 1.27.95 1.5c.01.03.12.32.12.81v16.37c0 .83-.34 1.59-.88 2.13s-1.3.88-2.13.88H60.48c-.52 0-.84-.13-.9-.15c-1-.31-1.77-1.12-2.02-2.14c-.01-.02-.02-.04-.02-.06c0 0-.65 1.3-.38 2.44c.25 1.03 1.32 1.91 3.32 1.91h51.96c2.77 0 5.02-2.25 5.02-5.02l-.01-13.97z",
    fill: "#fff59d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.99b6b81e611365450722fcc48e469613.svg";
export { ForwardRef as ReactComponent };